/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import FinishAction from './FinishAction/index'
import ImageSeries from './ImageSeries/index'
import Images from './Images/index'
import Patient from './Patient/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let constantData = fromHelpers.restrictions('restrictions')
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 autoProceed={true}
 data="'restrictions'"
 format="helpers.js restrictions"
 restrictions={constantData}
>
{childProps => (
<React.Fragment>
<FileUploaderPluginS3
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 isLegacyBucket={true}
 excludeKeyFileExtension={true}
/>
<Images
{...childProps}
  viewPath={`${viewPath}/Images`}
/>
</React.Fragment>
)}
</FileUploaderProvider>
<FinishAction
  viewPath={`${viewPath}/FinishAction`}
/>
</div>
{children}
</React.Fragment>)
}